import { render, staticRenderFns } from "./CallToActionButton.vue?vue&type=template&id=d8a3fd8c&scoped=true&"
import script from "./CallToActionButton.vue?vue&type=script&lang=js&"
export * from "./CallToActionButton.vue?vue&type=script&lang=js&"
import style0 from "./CallToActionButton.vue?vue&type=style&index=0&id=d8a3fd8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a3fd8c",
  null
  
)

export default component.exports